import * as React from "react";
import Box from "@mui/joy/Box";
import IconButton from "@mui/joy/IconButton";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Avatar from "@mui/joy/Avatar";
import Menu from "@mui/joy/Menu";
import MenuItem from "@mui/joy/MenuItem";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Divider from "@mui/joy/Divider";

import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import HoverButton from "app/components/Common/HoverButton";

import { Logo_BLUE, Logo } from "assets";
import { useNavigate, } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { uiStateActions } from "store/UIStateStore/slice";
import { useUserStoreSlice } from "store/UserStore/slice";
import { selectUserStore } from "store/UserStore/slice/selectors";
import { useAuth } from "aws/AuthContext";
import useOutsideClick from "app/hooks/useOutsideClick";
import { Dropdown, MenuButton, Stack, Tooltip, Typography } from "@mui/joy";
import CardHelp from "app/components/CardHelp/CardHelp";
import MoreInfoButton from "app/components/MoreInfoButton/MoreInfoButton";
import NotificationPanel from "app/components/NotificationPanel/NotificationPanel";
import { ROOT_ROUTE } from "app/constants/route";
import ListInfoMenu from "app/components/ListInfoMenu/ListInfoMenu";
import { useMediaQuery } from "@mui/material";

type HeaderProps = {
  description?: string;
  breadcrumbs: {
    href?: string;
    text: string;
  }[];
  tabs?: {
    href?: string;
    text: string;
  }[];
  onTabChange?: (index: number) => void;
  showBackButton?: boolean;
};

export function PageHeader(props: HeaderProps) {
  const navigate = useNavigate();
  const { logout, user: authUser } = useAuth();
  const dispatch = useDispatch();
  const { actions: userStoreActions } = useUserStoreSlice();

  const userStore = useSelector(selectUserStore);


  const handleSignOut = async () => {
    try {
      await logout();
      dispatch(userStoreActions.resetState());
      navigate(ROOT_ROUTE);
    } catch (e) {
      console.error("Sign Out Error: ", e);
    }
  };
  const isMediaMD = useMediaQuery((theme: any) => theme?.breakpoints?.up('md'));
  const isMediaSM = useMediaQuery((theme: any) => theme?.breakpoints?.up('sm'));


  return (
    <Box
      sx={{
        position: "sticky",
        top: { sm: -100, md: -110 },
        bgcolor: "background.body",
        height: "64px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 1,
      }}
      borderBottom={1}
      borderColor={"divider"}
    >
      <HoverButton
        onClick={() => {
          dispatch(uiStateActions.toggleSidebar());
        }}
        icon={<MenuRoundedIcon />}
      />

      <Box sx={{ display: "flex", alignItems: "center", flex: 0 }}>
        <Box
          onClick={() => navigate(ROOT_ROUTE)}
          aria-label="Home"
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          <img src={isMediaSM ? Logo_BLUE : Logo} alt="Logo" style={{ height: "24px" }} />
        </Box>
      </Box>

      <Box sx={{ display: "flex", flex: 1, justifyContent: "center" }}>
      </Box>

      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <ListInfoMenu type='list-icon' />
        <NotificationPanel />
        <CardHelp />
        <Dropdown>
          <MenuButton variant="plain" sx={{ px: 0, py: 1 }}>
            <IconButton
              id="profile-button"
              variant="plain"
              color="neutral"
              sx={{
                transition: "transform 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "transparent",
                  transform: "scale(1.1)",
                },
              }}
            >
              {userStore.profilePic ? (
                <Avatar size="md" src={userStore.profilePic} />
              ) : (
                <Avatar size="md">
                  <PersonRoundedIcon />
                </Avatar>
              )}
            </IconButton>
          </MenuButton>
          <Menu>
            <ListInfoMenu type='list-menu' />
            
            {authUser?.email && (
              <MenuItem disabled>
                <Typography level="body-sm" textColor="neutral.500">
                  {authUser.email}
                </Typography>
              </MenuItem>
            )}
            
            <Divider sx={{ display: { xs: 'grid', md: 'grid' } }} />
            <MenuItem onClick={handleSignOut}>
              <LogoutRoundedIcon />
              <Typography ml={1}>Sign out</Typography>
            </MenuItem>
          </Menu>
        </Dropdown>
      </Box>
    </Box>
  );
}
